<template>
  <div>
    <div class="gender-bar" v-if="(profile_data.female_ratio > 0 && profile_data.male_ratio > 0)">
      <div v-show="graph_gender == '全て'" class="female-box" :style="{ width: profile_data.female_ratio + '%' }">
        <font-awesome-icon icon="female" style="margin-right:6px" />
        <div class="female-ratio">{{ profile_data.female_ratio }}</div>
        %
      </div>
      <div v-show="graph_gender == '全て'" class="male-box" :style="{ width: profile_data.male_ratio + '%' }">
        <div class="male-ratio">{{ profile_data.male_ratio }}</div>
        %
        <font-awesome-icon icon="male" style="margin-left:6px" />
      </div>
    </div>
    <div class="gender-bar" v-else>
      <div class="no-data">データがありません</div>
    </div>
    <div class="profile-gender-detail-wrap" v-if="profile_data.audience">
      
      <div class="profile-gender-detail-center" :style="'right:-40px'">
        <div v-for="(audience_rate, index) in profile_data.audience.female" :key="index" class="profile-gender-detail-title">
            {{ audienceRateByGender(profile_data, graph_gender, index) }}%
          </div>
      </div>
      
      <div v-if="graph_gender == '全て'" class="profile-gender-detail-female" :style="'width:' + profile_data.female_ratio + '%'">
        <el-tooltip v-for="female_audience in profile_data.audience.female" :key="female_audience.name">
          <div slot="content">
            <div style="margin-bottom: 3px;"><font-awesome-icon icon="female" style="margin-right:6px" />{{ female_audience.name }}</div>
            <div>{{ female_audience.data }}%</div>
          </div>
          <div class="female-box detail" :style="{ width: female_audience.width + '%' }"></div>
        </el-tooltip>
      </div>
      
      <div v-else-if="graph_gender == '女性'" class="profile-gender-detail-male" :style="'width:' + profile_data.female_ratio + '%'" style="margin-left: 28px;" >
        <el-tooltip v-for="(female_audience, index) in profile_data.audience.female" :key="female_audience.name">
          <div slot="content">
            <div style="margin-bottom: 3px;"><font-awesome-icon icon="female" style="margin-right:6px" />{{ female_audience.name }}</div>
            <div>{{ audienceRateByGender(profile_data, graph_gender, index) }}%</div>
          </div>
          <div class="female-box detail" style="border-radius: 0 5px 5px 0;" :style="{ width: audienceRateByGender(profile_data, graph_gender, index) + '%' }"></div>
        </el-tooltip>
      </div>
      
      <!-- instagram用 --->
      <div v-if="profile_data.ig_id" class="profile-gender-detail-center">
        <div class="profile-gender-detail-title">13-17</div>
        <div class="profile-gender-detail-title">18-24</div>
        <div class="profile-gender-detail-title">25-34</div>
        <div class="profile-gender-detail-title">35-44</div>
        <div class="profile-gender-detail-title">45-54</div>
        <div class="profile-gender-detail-title">55+</div>
      </div>
      
      <!-- TikTok用 --->
      <div v-if="profile_data.tt_id" class="profile-gender-detail-center">
        <div class="profile-gender-detail-title">13-17</div>
        <div class="profile-gender-detail-title">18-24</div>
        <div class="profile-gender-detail-title">25-34</div>
        <div class="profile-gender-detail-title">35-44</div>
        <div class="profile-gender-detail-title">45+</div>
      </div>
      
      <div v-if="graph_gender == '全て'" class="profile-gender-detail-male" :style="'width:' + profile_data.male_ratio + '%'">
        <el-tooltip v-for="male_audience in profile_data.audience.male" :key="male_audience.name">
          <div slot="content">
            <div style="margin-bottom: 3px;"><font-awesome-icon icon="male" style="margin-right:6px" />{{ male_audience.name }}</div>
            <div>{{ male_audience.data }}%</div>
          </div>
          <div class="male-box detail" :style="{ width: male_audience.width + '%' }"></div>
        </el-tooltip>
      </div>
      
      <div v-else-if="graph_gender == '男性'" class="profile-gender-detail-male" :style="'width: 100%'" style="margin-left: 30px;" >
        <el-tooltip v-for="(male_audience, index) in profile_data.audience.male" :key="male_audience.name">
          <div slot="content">
            <div style="margin-bottom: 3px;"><font-awesome-icon icon="male" style="margin-right:6px" />{{ male_audience.name }}</div>
            <div>{{ audienceRateByGender(profile_data, graph_gender, index) }}%</div>
          </div>
          <div class="male-box detail" :style="{ width: audienceRateByGender(profile_data, graph_gender, index) + '%' }"></div>
        </el-tooltip>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  props: ["profile_data", "graph_gender"],
  name: "genderBar",
  data() {
    return {
      detail_loading: true,
      tagged_user: false,
    };
  },
  methods: {
    audienceRateByGender(profile_data, gender, index) {
      
      let audience = profile_data.audience;
      let female_ratio = profile_data.female_ratio;
      let male_ratio = profile_data.male_ratio;
      let rate_num = 0;
                
      if(audience) {
        if (gender == "全て") {
          rate_num = audience.female[index].data + audience.male[index].data;
        } else if (gender == "女性") {
          rate_num = female_ratio >= 0 ? Math.round(audience.female[index].data/female_ratio * 100) : 0;
        } else if (gender == "男性") {
          rate_num = male_ratio >=0 ? Math.round(audience.male[index].data/male_ratio * 100) : 0;
        }        
      } else {
        // データが正しくない場合は非表示
        rate_num = "-";
      }
      
      return rate_num;
    }
  },
  filters: {

  },
};
</script>

<style></style>
